import type { PublishCourseDraft200SectionsItemLecturesItem } from './publishCourseDraft200SectionsItemLecturesItem';

export type PublishCourseDraft200SectionsItem = {
  id: number;
  lectures: PublishCourseDraft200SectionsItemLecturesItem[];
  title: string;
};
